export default "__VITE_ASSET__DyXk_Cw6__"